import PropTypes from "prop-types";

import React from "react"

//i18n
import { withTranslation } from "react-i18next";
// Forms
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  InputGroup,
} from "reactstrap";

// Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
// Editable Grid
import DynamicEditableGrid from "../../../components/Grid/DynamicEditableGrid";

const Journal = (props) => {

  // Get current language from localStorage (or from i18n directly)
  const lang = localStorage.getItem("I18N_LANGUAGE") || "eng";

  // Determine text direction
  const isRTL = lang === "ar";

  //meta title
  document.title = props.t("JournalVoucher");

  const columns = [
    { field: "accountno", headerName: props.t("Account No"), 
      type: 'singleSelect',
      valueOptions: ['Market', 'Finance', 'Development'],
      width: 100, editable: true 
    },
    {
      field: 'accountname',
      headerName: props.t("Account Name"),
      type: 'singleSelect',
      valueOptions: ['Market', 'Finance', 'Development'],
      width: 70  ,
      align: 'left',
      headerAlign: 'left',
      editable: true,
    },
    {
      field: 'debit',
      headerName: props.t("Debit"),
      type: 'singleSelect',
      valueOptions: ['Market', 'Finance', 'Development'],
      width: 70,
      editable: true,
    },
    {
      field: 'credit',
      headerName: props.t("Credit"),
      width: 70,
      editable: true,
      type: 'singleSelect',
      valueOptions: ['Market', 'Finance', 'Development'],
    },
    {
      field: 'description',
      headerName: props.t("Description"),
      width: 180,
      editable: true,
      type: 'area',
    },
    {
      field: 'costno',
      headerName: props.t("Cost No"),
      width: 70,
      editable: true,
      type: 'singleSelect',
      valueOptions: ['Market', 'Finance', 'Development'],
    },
    {
      field: 'costcenter',
      headerName: props.t("Cost Center"),
      width: 70,
      editable: true,
      type: 'singleSelect',
      valueOptions: ['Market', 'Finance', 'Development'],
    },
    {
      field: 'jobno',
      headerName: props.t("Job No"),
      width: 70,
      editable: true,
      type: 'singleSelect',
      valueOptions: ['Market', 'Finance', 'Development'],
    },
    {
      field: 'invoiceno',
      headerName: props.t("Invoice No"),
      width: 70,
      editable: true,
      type: 'singleSelect',
      valueOptions: ['Market', 'Finance', 'Development'],
    },
  ];

  const data = [
    { id: 1, name: 'John Doe', age: 25, joinDate: new Date(), role: 'Market' },
    { id: 2, name: 'Jane Smith', age: 30, joinDate: new Date(), role: 'Finance' },
  ];

  const emptyRowTemplate = {  };

  return (
    <React.Fragment>
      <div className="page-content">
          <Breadcrumbs title={props.t("Voucher")} breadcrumbItem={props.t("Journal")} />
        <Container fluid={true} dir={isRTL ? "rtl" : "ltr"}>

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Form>

                    <Row>
                      <Col md={3}>
                        <div className="mb-3">
                          <Label htmlFor="formrow-voucher-Input">{props.t("Journal")}</Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="formrow-voucher-Input"

                          />
                        </div>
                      </Col>
                      <Col md={3}>
                        <div className="">
                          <label
                            htmlFor="example-date-input"
                          >
                            {props.t("Date")}
                          </label>
                          <div className="col-md-10">
                            <input
                              className="form-control"
                              type="date"
                              defaultValue="2019-08-19"
                              id="example-date-input"
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <Col lg={4}>
                        <div className="mb-3">
                          <Label htmlFor="formrow-InputDescription">
                          {props.t("Description")}
                          </Label>
                          <Input
                            type="textarea"
                            className="form-control"
                            id="formrow-InputDescription"
                          />
                        </div>
                      </Col>

                    </Row>

                    <button type="submit" className="btn btn-primary w-md float-end">
                      {props.t("Submit")}
                    </button>

                    <div>

                    </div>
                  </Form>
                </CardBody>
              </Card>

              {/* Editable Grid */}
              <Card>
                <CardBody>
                  <div className="table-responsive">
                    <DynamicEditableGrid columns={columns}
                      initialRows={data} emptyRowTemplate={emptyRowTemplate} />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
Journal.propTypes = {
  t: PropTypes.any,
};



export default withTranslation()(Journal);
